import { Settings } from "luxon";

let locale: string | undefined = undefined;

const setLocale = (nextLocale: string) => {
  locale = nextLocale;
  Settings.defaultLocale = nextLocale;
};

const currencyFormatter = (
  currency: string,
  options: Intl.NumberFormatOptions = {},
) =>
  new Intl.NumberFormat(locale, {
    currency,
    style: "currency",
    ...options,
  });

const numberFormatter = (options: Intl.NumberFormatOptions = {}) =>
  new Intl.NumberFormat(locale, options);

const percentageFormatter = new Intl.NumberFormat(locale, {
  maximumFractionDigits: 1,
  minimumFractionDigits: 1,
  style: "percent",
});

const dateFormatter = (options: Intl.DateTimeFormatOptions = {}) =>
  new Intl.DateTimeFormat(locale, options);

const getPrice = (cents: number, precision: number) =>
  cents / Math.pow(10, precision);

export {
  currencyFormatter,
  dateFormatter,
  getPrice,
  numberFormatter,
  percentageFormatter,
  setLocale,
};
